// Home.jsx
import React, { useEffect, useMemo, useState } from "react";
import Gallery from "../components/FiberElements/Gallery";

// URLs base
const collection1BaseUrl =
  "https://raw.githubusercontent.com/CoachblockchainDapp/AquaCollection/refs/heads/main/";
const collection2BaseUrl =
  "https://raw.githubusercontent.com/CoachblockchainDapp/ImagenesEar/refs/heads/main/";
const collection3BaseUrl =
  "https://raw.githubusercontent.com/CoachblockchainDapp/TerraImages/refs/heads/main/";

function getRandomImageUrl() {
  const totalWeight = 50 + 40 + 10;
  const random = Math.random() * totalWeight;

  if (random < 50) {
    const id = Math.floor(Math.random() * (10280 - 10181 + 1)) + 10181;
    return `${collection3BaseUrl}${id}.png`;
  } else if (random < 50 + 40) {
    const id = Math.floor(Math.random() * (140 - 47 + 1)) + 47;
    return `${collection1BaseUrl}${id}.png`;
  } else {
    const id = Math.floor(Math.random() * 97) + 1;
    return `${collection2BaseUrl}${id}.png`;
  }
}

const POSITIONS = [
  { position: [0, 0, 1.5], rotation: [0, 0, 0] },
  { position: [-0.8, 0, -0.8], rotation: [0, 0, 0] },
  { position: [0.8, 0, -0.8], rotation: [0, 0, 0] },
  { position: [-2, 0, -0.1], rotation: [0, Math.PI / 2.5, 0] },
  { position: [-2.15, 0, 1.5], rotation: [0, Math.PI / 2.5, 0] },
  { position: [-2, 0, 2.8], rotation: [0, Math.PI / 2.5, 0] },
  { position: [2, 0, -0.1], rotation: [0, -Math.PI / 2.5, 0] },
  { position: [2.15, 0, 1.5], rotation: [0, -Math.PI / 2.5, 0] },
  { position: [2, 0, 2.8], rotation: [0, -Math.PI / 2.5, 0] },
];

// ✅ Precarga de imágenes (evita “blanco”)
function preloadImages(urls, timeoutMs = 12000) {
  return Promise.all(
    urls.map(
      (url) =>
        new Promise((resolve) => {
          const img = new Image();

          const done = () => resolve(true);

          const t = setTimeout(() => {
            // si tarda mucho, no bloqueamos el home
            try {
              img.src = "";
            } catch {}
            done();
          }, timeoutMs);

          img.onload = () => {
            clearTimeout(t);
            done();
          };
          img.onerror = () => {
            clearTimeout(t);
            done();
          };

          // tip: fuerza CORS-friendly fetch en algunos navegadores
          img.crossOrigin = "anonymous";
          img.src = url;
        })
    )
  );
}

export default function Home({ marketplace, nft }) {
  // ✅ imágenes fijas 1 sola vez
  const images = useMemo(() => {
    return POSITIONS.map((p) => ({ ...p, url: getRandomImageUrl() }));
  }, []);

  const [ready, setReady] = useState(false);
  const [loadingText, setLoadingText] = useState("Cargando NFTs...");

  // ✅ 1) Precarga imágenes del Gallery antes de renderizarlo
  useEffect(() => {
    let cancelled = false;

    (async () => {
      setReady(false);
      setLoadingText("Cargando NFTs...");

      const urls = images.map((x) => x.url);
      await preloadImages(urls, 12000);

      if (!cancelled) setReady(true);
    })();

    return () => {
      cancelled = true;
    };
  }, [images]);

  // ✅ 2) Tu lógica marketplace (pero NO bloquea el render)
  useEffect(() => {
    let cancelled = false;

    async function loadMarketplaceItem() {
      try {
        const hasMarketplace =
          marketplace &&
          typeof marketplace.itemCount === "function" &&
          typeof marketplace.items === "function";

        const hasNft = nft && typeof nft.tokenURI === "function";

        if (!hasMarketplace || !hasNft) return;

        // opcional: si quieres mostrar status
        // if (!cancelled) setLoadingText("Leyendo marketplace...");

        const itemCountBN = await marketplace.itemCount();
        const itemCount =
          typeof itemCountBN?.toNumber === "function"
            ? itemCountBN.toNumber()
            : Number(itemCountBN);

        if (!Number.isFinite(itemCount) || itemCount <= 0) return;

        for (let i = 1; i <= itemCount; i++) {
          if (cancelled) return;
          const item = await marketplace.items(i);
          if (!item) continue;

          // aquí solo “toco” URIs para validar, sin romper si falla
          try {
            const tokenId =
              typeof item.tokenId?.toString === "function"
                ? item.tokenId.toString()
                : String(item.tokenId);

            const uri = await nft.tokenURI(tokenId);
            if (!uri || typeof uri !== "string") continue;

            // si quieres, valida fetch (no obligatorio)
            // await fetch(uri).catch(() => {});
          } catch {
            continue;
          }
        }
      } catch (e) {
        console.error("loadMarketplaceItem:", e);
      }
    }

    loadMarketplaceItem();
    return () => {
      cancelled = true;
    };
  }, [marketplace, nft]);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        minHeight: "100dvh",
        overflow: "hidden",
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
      }}
    >
      <main
        style={{
          position: "relative",
          width: "100%",
          minHeight: "100dvh",
          margin: 0, // ✅ sin marginTop
          padding: 0,
        }}
      >
        {/* ✅ Mientras no esté listo, mostramos loader FULL */}
        {!ready && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#0b1220",
              zIndex: 5,
              padding: 16,
              boxSizing: "border-box",
              textAlign: "center",
            }}
          >
            <div
              style={{
                maxWidth: 520,
                width: "100%",
                color: "#fff",
                fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial",
              }}
            >
              <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
                {loadingText}
              </div>
              <div style={{ opacity: 0.85, fontSize: 14 }}>
                Espera un momento… cargando imágenes.
              </div>

              <div
                style={{
                  marginTop: 16,
                  height: 6,
                  width: "100%",
                  background: "#FFF",
                  borderRadius: 999,
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    height: "100%",
                    width: "55%",
                    background: "#FFF",
                    borderRadius: 999,
                    animation: "homeLoading 1.2s ease-in-out infinite",
                  }}
                />
              </div>

              <style>{`
                @keyframes homeLoading {
                  0% { transform: translateX(-60%); }
                  50% { transform: translateX(40%); }
                  100% { transform: translateX(140%); }
                }
              `}</style>
            </div>
          </div>
        )}

        {/* ✅ Gallery renderiza solo cuando las imágenes ya están precargadas */}
        {ready && <Gallery images={images} />}
      </main>
    </div>
  );
}
